import React, { useState } from 'react';
import Avatar from './ui/Avatar';
import Badge from './ui/Badge';
import Button from './ui/Button';
import { Phone as _lr_Phone, Mail as _lr_Mail, MapPin as _lr_MapPin, Briefcase as _lr_Briefcase, Star as _lr_Star, PhoneCall as _lr_PhoneCall, MessageSquare as _lr_MessageSquare } from 'lucide-react';
import CallModal from './CallModal';
import { AnimatePresence } from 'framer-motion';

const Phone = _lr_Phone || (() => null);
const Mail = _lr_Mail || (() => null);
const MapPin = _lr_MapPin || (() => null);
const Briefcase = _lr_Briefcase || (() => null);
const Star = _lr_Star || (() => null);
const PhoneCall = _lr_PhoneCall || (() => null);
const MessageSquare = _lr_MessageSquare || (() => null);
const stageBadge = { Applied: 'default', Screening: 'info', Shortlisted: 'warning', Interview: 'warning', Offer: 'success' };

export function CandidateDetail({ candidate: c = {}, onClose }) {
  const [showCall, setShowCall] = useState(false);

  return (
    <div className="space-y-5">
      <div className="flex items-start gap-4">
        <Avatar src={c.avatar} name={c.name || ''} size="lg" />
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-bold text-gray-900">{c.name}</h3>
          <p className="text-sm text-gray-500">{c.role} · {c.department}</p>
          <div className="flex items-center gap-2 mt-1">
            <Badge variant={stageBadge[c.stage] || 'default'}>{c.stage}</Badge>
            <span className="text-xs font-bold text-purple-600 bg-purple-50 px-2 py-0.5 rounded-full">AI Score: {c.score}%</span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 text-sm">
        <div className="flex items-center gap-2 text-gray-600"><Mail size={14} className="text-purple-500" />{c.email}</div>
        <div className="flex items-center gap-2 text-gray-600"><Phone size={14} className="text-purple-500" />{c.phone}</div>
        <div className="flex items-center gap-2 text-gray-600"><MapPin size={14} className="text-purple-500" />{c.location}</div>
        <div className="flex items-center gap-2 text-gray-600"><Briefcase size={14} className="text-purple-500" />{c.experience} exp.</div>
      </div>
      <div className="bg-purple-50 rounded-lg p-3 border border-purple-100">
        <p className="text-xs font-semibold text-purple-700 mb-1 uppercase tracking-wider">AI Screening Summary</p>
        <p className="text-sm text-gray-700 leading-relaxed">
          Strong match for the role. Candidate demonstrates solid technical background with {c.experience} of relevant experience. 
          Communication skills rated excellent during AI screening call. Recommended for next stage.
        </p>
      </div>
      <div className="flex gap-2 flex-wrap pt-2">
        <Button size="sm" onClick={() => setShowCall(true)} className="gap-1.5 bg-purple-600 hover:bg-purple-700">
          <PhoneCall size={14} /> AI Screen Call
        </Button>
        <Button size="sm" variant="outline" className="gap-1.5">
          <MessageSquare size={14} /> Send Message
        </Button>
        <Button size="sm" variant="secondary" className="gap-1.5">
          <Star size={14} /> Shortlist
        </Button>
      </div>

      <AnimatePresence>
        {showCall && (
          <CallModal 
            candidate={"C"} 
            onClose={() => setShowCall(false)} 
          />
        )}
      </AnimatePresence>
    </div>
  );
}

export default CandidateDetail;